import React, { useEffect, useState } from 'react';
import { Button, Col, Container, Row } from 'react-bootstrap';
import PaginationComponent from 'Components/Common/Pagination/Pagination';
import { useHistory } from 'react-router-dom';
import SpinnerComponent from 'Components/Common/SpinnerComponent';
import useMessage from 'Hooks/useMessage';
import { PER_PAGE } from 'Constant';
import { useQueryParams, NumberParam } from 'use-query-params';
import CampaignTable from 'Components/Page/Campaign/CampaignTable';
import { CampaignApis } from 'Datasource/Campaign';

export default function CampaignList(): JSX.Element {
  const [loading, setLoading] = useState<boolean>(false);
  const [campaigns, setCampaigns] = useState<any>([]);
  const history = useHistory();
  const { openMessageError } = useMessage();
  const [query] = useQueryParams({
    page: NumberParam,
  });
  const [page, setPage] = useState(query.page ?? 1);
  const [total, setTotal] = useState(0);
  const handleGetCampaign = async () => {
    try {
      setLoading(true);
      const { data } = await CampaignApis.getAll({
        page,
      });

      setTotal(data.totalCount);
      setCampaigns(data.campaigns);
    } catch (error) {
      openMessageError(error);
    } finally {
      setLoading(false);
    }
  };

  const onChangePage = (page: number) => {
    setPage(page);
  };

  useEffect(() => {
    handleGetCampaign();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page]);

  return (
    <>
      <Container fluid>
        <Row>
          <Col md="8" className="d-flex justify-content-start px-4 pt-4">
            <Button
              onClick={() => history.push(`/admin/campaigns/register`)}
              className="btn-focus-none px-3 button-submit"
            >
              Tạo chiến dịch
            </Button>
          </Col>
        </Row>
        <div className="px-4">
          <SpinnerComponent isLoading={loading} />
          <Row className="my-3">
            <Col md={12} className="d-flex justify-content-end p-0">
              <PaginationComponent
                onClick={onChangePage}
                activePage={page}
                total={total}
                perPage={PER_PAGE}
              />
            </Col>
          </Row>
          <CampaignTable dataSource={campaigns || []} />
        </div>
      </Container>
    </>
  );
}
